import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import SidebarContext from "../../../context/SidebarContext";
import Header from "./Header";
import { Form, useLocation, useNavigate } from "react-router-dom";
import SimpleBar from "simplebar-react";
import VideoUploader from "./VideoUploder";
import ReactQuill from "react-quill";
import { useFormik } from "formik";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  onSnapshot,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db, storage } from "../../../firebaseConfig";
import { toast } from "react-toastify";
import Select from "react-select";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";

const modules = {
  toolbar: [
    [{ font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    ["blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ direction: "rtl" }, { align: [] }],
    ["link", "image", "video"],
    ["clean"],
  ],
};

const formats = [
  "font",
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "blockquote",
  "code-block",
  "list",
  "bullet",
  "indent",
  "direction",
  "align",
  "link",
  "image",
  "video",
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const videonames = [
  "Video Snippet 1",
  "Video Snippet 2",
  "Video Snippet 3",
  "Video Snippet 4",
  "Video Snippet 5",
];

const articleName = [
  "Article Snippet 1",
  "Article Snippet 2",
  "Article Snippet 3",
  "Article Snippet 4",
  "Article Snippet 5",
];

const initialValue = {
  snippetType: "Video",
  cleverPageName: "",
  snippetName: "",
  snippetDescription: "",
  snippetLocator: "",
  topic: "",
  aboutFeature: "",
  relatedArticle: [],
  lastUpdatedDate: "",
  selectedLanguage: "",
};

export default function AddClever() {
  const { open } = useContext(SidebarContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // const [initialValues, setInitialValues] = useState(initialValue);
  const [snippetData, setSnippetData] = useState([]);
  const [selectedfiles, setSelectedFiles] = useState([]);
  const onUploadPhoto = async (file) => {
    setSelectedFiles(file);
  };

  useEffect(() => {
    const querySnapshot = collection(db, "cleverSnippet");
    const q = query(querySnapshot);
    onSnapshot(q, async (snapshot) => {
      const arr = [];
      const finalarr = [];
      snapshot.forEach((doc) => {
        arr.push({ ...doc.data() });
      });
      console.log(arr, "arr of snippet");
      for (let d of arr) {
        const querySnapshot = await getDocs(
          collection(db, "cleverSnippet", d.cleverPageName, "snippets")
        );
        // console.log(querySnapshot.docs, "querySnapshot");
        querySnapshot.docs.map((doc) =>
          finalarr.push({
            ...doc.data(),
            cleverPageName: d.cleverPageName,
            id: doc?.id,
          })
        );
      }
      setSnippetData(finalarr);
      console.log(finalarr, "finalarr of snippet");
    });
  }, []);
  useEffect(() => {
    if (location?.state?.id) {
      const editData = location?.state?.row;
      console.log(editData, "editData");
      editData?.videoSnippet && setSelectedFiles([editData?.videoSnippet]);
      formik.setValues(editData);
      // setMessageQuillValue(editData.snippetDescription);
      // setAboutQuillValue(editData.aboutFeature);
    }
  }, [location?.state?.id]);

  const formik = useFormik({
    initialValues: initialValue,
    enableReinitialize: true,

    onSubmit: async (values) => {
      console.log(values, "values in add snippet");
      setLoading(true);

      // const cleverPageRef = doc(db, "cleverSnippet", values.cleverPageName);
      // const cleverPageDoc = await getDoc(cleverPageRef);

      if (location?.state?.id) {
        const extra = {};
        console.log(typeof selectedfiles[0], selectedfiles[0]);
        if (values.snippetType === "Article") {
          extra["videoSnippet"] = "";
        } else {
          extra["snippetDescription"] = "";
          extra["topic"] = "";
          extra["aboutFeature"] = "";
          if (
            selectedfiles?.length > 0 &&
            typeof selectedfiles[0] !== "string"
          ) {
            const storageRef1 = ref(
              storage,
              `/cleverSnippets/${selectedfiles[0]?.name}`
            );
            const uploadTask1 = uploadBytesResumable(
              storageRef1,
              selectedfiles[0]
            );
            const [snapshot1] = await Promise.all([uploadTask1]);

            const videoURL = await getDownloadURL(snapshot1.ref);
            extra["videoSnippet"] = videoURL;
          } else if (selectedfiles?.length === 0) {
            extra["videoSnippet"] = "";
          }
        }
        const snippetData = {
          snippetType: values.snippetType,
          snippetName: values.snippetName,
          snippetDescription: values.snippetDescription,
          snippetLocator: values.snippetLocator,
          aboutFeature: values.aboutFeature,
          topic: values.topic,
          relatedArticle: values.relatedArticle,
          selectedLanguage: values.selectedLanguage,
          lastUpdatedDate: new Date(),
          ...extra,
        };

        await updateDoc(
          doc(
            db,
            "cleverSnippet",
            values.cleverPageName,
            "snippets",
            location?.state?.id
          ),
          {
            ...snippetData,
          }
        )
          .then(() => {
            navigate("/users/clever");
            setLoading(false);
            toast.success("Snippet Updates Successfully!");
          })
          .catch((error) => {
            toast.error("Snippet not update.Try again later!");
            setLoading(false);
          });
      } else {
        const storageRef1 = ref(
          storage,
          `/cleverSnippets/${selectedfiles[0]?.name}`
        );
        const uploadTask1 = uploadBytesResumable(storageRef1, selectedfiles[0]);
        const [snapshot1] = await Promise.all([uploadTask1]);

        const videoURL = await getDownloadURL(snapshot1.ref);
        console.log(videoURL, "videoURL");
        const snippetData = {
          snippetType: values.snippetType,
          snippetName: values.snippetName,
          snippetDescription: values.snippetDescription,
          snippetLocator: values.snippetLocator,
          aboutFeature: values.aboutFeature,
          topic: values.topic,
          videoSnippet: videoURL,
          selectedLanguage: values.selectedLanguage,
          relatedArticle: values.relatedArticle,
          isActive: true,
          noCount: 0,
          snippetViews: 0,
          yesCount: 0,
          articleViews: 0,
          lastSeenDate: null,
          lastUpdatedDate: new Date(),
          createdDate: new Date(),
        };
        setDoc(doc(db, "cleverSnippet", values.cleverPageName), {
          cleverPageName: values.cleverPageName,
        }).then(async (res) => {
          await addDoc(
            collection(db, "cleverSnippet", values.cleverPageName, "snippets"),
            {
              ...snippetData,
            }
          ).then(() => {
            navigate("/users/clever");
            setLoading(false);
            toast.success("New Snippet Added Successfully!");
          });
        });
      }
    },
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "96vh",
        margin: "20px",
        marginRight: "0px",
        width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "12px",
      }}
    >
      <Box sx={{ borderBottom: "1px solid #E5E5E8" }}>
        <Header
          pageTitle={`${location?.state?.id ? "Edit" : "Add"} Snippet`}
          currentRoute={`${location?.state?.id ? "Edit" : "Add"} Snippet`}
          buttonName="Add Snippet"
          //   handleCancle={() => handleCancle()}
          loading={loading}
          //   handleSave={formik.handleSubmit}
        />
      </Box>
      <SimpleBar
        forceVisible="y"
        autoHide={true}
        style={{
          maxHeight: "82vh",
        }}
        className="custom-scrollbar"
      >
        {/* <Form onSubmit={formik.handleSubmit}> */}
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box>
              <Stack direction={"row"} sx={{ marginTop: "20px" }}>
                <Stack>
                  <Box>
                    <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                      Snippet Type
                    </Typography>
                  </Box>
                  <RadioGroup
                    row
                    aria-labelledby="conditionPackage-label"
                    name="conditionPackage"
                    value={formik.values?.snippetType}
                    onChange={(e) => {
                      formik.setValues((prev) => ({
                        ...prev,
                        relatedArticle: [],
                        snippetType: e.target.value,
                        selectedLanguage: "",
                        aboutFeature: "",
                        topic: "",
                        snippetDescription: "",
                      }));
                      setSelectedFiles([]);
                      // formik.setFieldValue("snippetType", e.target.value);
                    }}
                  >
                    <FormControlLabel
                      control={<Radio />}
                      value="Video"
                      label="Video"
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="Article"
                      label="Article"
                    />
                  </RadioGroup>
                </Stack>
              </Stack>
              <Stack direction={"row"} sx={{ marginTop: "20px" }}>
                <Stack>
                  <Box sx={{ marginBottom: "5px" }}>
                    <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                      Clever Page Name
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <FormControl
                      fullWidth
                      sx={{
                        m: 1,
                        mt: 0,
                        minWidth: "45vw",
                        minHeight: "35px",
                        marginLeft: "0px",
                      }}
                      size="small"
                    >
                      <OutlinedInput
                        fullWidth
                        type="text"
                        id="cleverPageName"
                        placeholder="Clever Page Name"
                        name="cleverPageName"
                        value={formik.values.cleverPageName}
                        onChange={formik.handleChange}
                        disabled={!!location?.state?.id}
                      />
                    </FormControl>
                  </Box>
                </Stack>
              </Stack>
              <Stack direction={"row"} sx={{ marginTop: "20px" }}>
                <Stack>
                  <Box sx={{ marginBottom: "5px" }}>
                    <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                      Snippet Name
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <FormControl
                      fullWidth
                      sx={{
                        m: 1,
                        mt: 0,
                        minWidth: "45vw",
                        minHeight: "35px",
                        marginLeft: "0px",
                      }}
                      size="small"
                    >
                      <OutlinedInput
                        fullWidth
                        type="text"
                        id="snippetName"
                        placeholder="Snippet Name"
                        name="snippetName"
                        value={formik.values.snippetName}
                        onChange={formik.handleChange}
                      />
                    </FormControl>
                  </Box>
                </Stack>
              </Stack>
              <Stack direction={"row"} sx={{ marginTop: "20px" }}>
                <Stack>
                  <Box sx={{ marginBottom: "5px" }}>
                    <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                      Snippet Locator
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <FormControl
                      fullWidth
                      sx={{
                        m: 1,
                        mt: 0,
                        minWidth: "45vw",
                        minHeight: "35px",
                        marginLeft: "0px",
                      }}
                      size="small"
                    >
                      <OutlinedInput
                        fullWidth
                        type="text"
                        id="snippetLocator"
                        placeholder="Snippet Locator"
                        name="snippetLocator"
                        value={formik.values.snippetLocator}
                        onChange={formik.handleChange}
                      />
                    </FormControl>
                  </Box>
                </Stack>
              </Stack>
              {formik.values?.snippetType === "Video" && (
                <Stack direction={"row"} sx={{ marginTop: "20px" }}>
                  <Stack>
                    <Box sx={{ marginBottom: "5px" }}>
                      <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                        Select Language
                      </Typography>
                    </Box>
                    <Box>
                      <FormControl
                        sx={{
                          m: 1,
                          mt: 0,
                          minWidth: "45vw",
                          minHeight: "35px",
                          marginLeft: "0px",
                        }}
                      >
                        <Select
                          name="selectedLanguage"
                          options={[
                            {
                              value: "English",
                              label: "English",
                            },
                            {
                              value: "German",
                              label: "German",
                            },
                          ]}
                          value={{
                            label: formik.values.selectedLanguage,
                            value: formik.values.selectedLanguage,
                          }}
                          onChange={(selectedOption) => {
                            formik.setFieldValue(
                              "selectedLanguage",
                              selectedOption.value
                            );
                          }}
                        />
                      </FormControl>
                    </Box>
                  </Stack>
                </Stack>
              )}
              <Stack direction={"row"} sx={{ marginTop: "20px" }}>
                <Stack>
                  <Box sx={{ marginBottom: "5px" }}>
                    <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                      {formik.values?.snippetType === "Video"
                        ? "Video"
                        : "Article Description"}
                    </Typography>
                  </Box>
                  <Box>
                    {formik.values?.snippetType === "Video" ? (
                      <VideoUploader
                        onChange={onUploadPhoto}
                        // // maxFiles={4}
                        value={selectedfiles}
                      />
                    ) : (
                      <ReactQuill
                        theme="snow"
                        modules={modules}
                        formats={formats}
                        value={formik.values.snippetDescription}
                        onChange={(value) => {
                          formik.setFieldValue("snippetDescription", value);
                        }}
                        style={{
                          minHeight: "150px",
                          maxWidth: "45vw",
                        }}
                      />
                    )}
                  </Box>
                </Stack>
              </Stack>
              {formik.values?.snippetType === "Article" && (
                <>
                  <Stack direction={"row"} sx={{ marginTop: "20px" }}>
                    <Stack>
                      <Box sx={{ marginBottom: "5px" }}>
                        <Typography
                          sx={{ fontSize: "13px", fontWeight: "600" }}
                        >
                          Topic
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <FormControl
                          fullWidth
                          sx={{
                            m: 1,
                            mt: 0,
                            minWidth: "45vw",
                            minHeight: "35px",
                            marginLeft: "0px",
                          }}
                          size="small"
                        >
                          <OutlinedInput
                            fullWidth
                            type="text"
                            id="topic"
                            placeholder="Topic"
                            name="topic"
                            value={formik.values.topic}
                            onChange={formik.handleChange}
                          />
                        </FormControl>
                      </Box>
                    </Stack>
                  </Stack>
                  <Stack direction={"row"} sx={{ marginTop: "20px" }}>
                    <Stack>
                      <Box sx={{ marginBottom: "5px" }}>
                        <Typography
                          sx={{ fontSize: "13px", fontWeight: "600" }}
                        >
                          Article Feature
                        </Typography>
                      </Box>
                      <Box>
                        <ReactQuill
                          theme="snow"
                          modules={modules}
                          formats={formats}
                          value={formik.values.aboutFeature}
                          onChange={(value) => {
                            formik.setFieldValue("aboutFeature", value);
                          }}
                          style={{
                            minHeight: "150px",
                            maxWidth: "45vw",
                          }}
                        />
                        <style jsx>{`
                          .ql-editor {
                            height: 20vh;
                          }
                        `}</style>
                      </Box>
                    </Stack>
                  </Stack>
                </>
              )}
              <Stack direction={"row"} sx={{ marginTop: "20px" }}>
                <Stack>
                  <Box sx={{ marginBottom: "5px" }}>
                    <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                      {formik.values?.snippetType === "Video"
                        ? " Related Video"
                        : " Related Article"}
                    </Typography>
                  </Box>
                  <FormControl
                    sx={{
                      m: 1,
                      mt: 0,
                      minWidth: "45vw",
                      minHeight: "35px",
                      marginLeft: "0px",
                    }}
                  >
                    <Select
                      isMulti
                      name="relatedArticle"
                      options={snippetData
                        ?.filter(
                          (item) =>
                            item?.selectedLanguage ===
                              formik.values?.selectedLanguage &&
                            item?.snippetType === formik.values.snippetType &&
                            item?.id !== location?.state?.id
                        )
                        ?.map((itm, i) => ({
                          value:
                            formik.values.snippetType === "Video"
                              ? itm.videoSnippet
                              : itm.snippetName,
                          label: itm.snippetName,
                        }))}
                      value={snippetData
                        ?.filter((item) =>
                          formik.values.relatedArticle?.includes(
                            formik.values.snippetType === "Video"
                              ? item?.videoSnippet
                              : item?.snippetName
                          )
                        )
                        .map((itm, i) => ({
                          value:
                            formik.values.snippetType === "Video"
                              ? itm.videoSnippet
                              : itm.snippetName,
                          label: itm.snippetName,
                        }))}
                      onChange={(selectedOptions) => {
                        console.log(selectedOptions, "selectedOptions");
                        // const limitedSelections = selectedOptions.slice(0, 3);
                        formik.setFieldValue(
                          "relatedArticle",
                          selectedOptions.map((option) => option.value)
                        );
                      }}
                    />
                  </FormControl>
                </Stack>
              </Stack>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Box className="me-3">
                <Button
                  variant="contained"
                  disabled={loading}
                  type="submit"
                  onClick={formik.handleSubmit}
                  sx={{
                    backgroundColor: "#5E17EB",
                    color: "#fff",
                    marginLeft: "20px",
                    minWidth: "126px",
                    border: "1px solid #E5E5E8",
                    borderRadius: "4px",
                    boxShadow: "none",
                    whiteSpace: "nowrap",
                    fontWeight: 600,
                    marginTop: "20px",
                    "&:hover": {
                      outline: "none",
                      color: "#fff",
                      backgroundColor: "#5E17EB",
                    },
                  }}
                >
                  {location?.state?.id ? "Edit" : "Add"} Snippit
                </Button>
              </Box>
              <Box>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "white",
                    color: "#1C2630",
                    border: "1px solid #E5E5E8",
                    minWidth: "126px",
                    borderRadius: "4px",
                    boxShadow: "none",
                    whiteSpace: "nowrap",
                    fontWeight: 600,
                    marginTop: "20px",
                    "&:hover": {
                      outline: "none",
                      color: "#1C2630",
                      backgroundColor: "white",
                    },
                  }}
                  onClick={() => {
                    navigate("/users/clever");
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
        {/* </Form> */}
      </SimpleBar>
    </Box>
  );
}
